import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, TextField, MenuItem, Button, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, CircularProgress } from '@mui/material';
import axios from '../api';

const tipos = [
  { value: '', label: 'Todos' },
  { value: 'access', label: 'Acesso' },
  { value: 'login', label: 'Login' },
  { value: 'usuario_criado', label: 'Usuário criado' },
  { value: 'convidado_criado', label: 'Convidado criado' },
  { value: 'convidado_alterado', label: 'Convidado alterado' },
  { value: 'convidado_confirmado', label: 'Confirmado' },
  { value: 'convidado_presente', label: 'Presente' },
  { value: 'convidado_excluido', label: 'Convidado excluído' },
  { value: 'despesa_criada', label: 'Despesa criada' },
  { value: 'despesa_pago', label: 'Parcela paga' },
];

function LogsAdmin() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroData, setFiltroData] = useState('');
  const [search, setSearch] = useState('');

  const carregarLogs = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filtroTipo) params.tipo = filtroTipo;
      if (filtroData) params.data = filtroData;
      if (search) params.search = search;
      const res = await axios.get('/api/logs', { params });
      setLogs(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarLogs();
  }, []);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>Logs do sistema</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField select label="Tipo" value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)} sx={{ minWidth: 180 }}>
            {tipos.map((item) => (
              <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
            ))}
          </TextField>
          <TextField label="Data" type="date" InputLabelProps={{ shrink: true }} value={filtroData} onChange={(e) => setFiltroData(e.target.value)} />
          <TextField label="Buscar" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ minWidth: 260 }} />
          <Button variant="contained" onClick={carregarLogs}>Aplicar filtros</Button>
        </Box>
      </Paper>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Usuário</TableCell>
                <TableCell>IP</TableCell>
                <TableCell>Detalhe</TableCell>
                <TableCell>Dados</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{new Date(log.created_at).toLocaleString('pt-BR')}</TableCell>
                  <TableCell>{log.tipo}</TableCell>
                  <TableCell>{log.usuario || '-'}</TableCell>
                  <TableCell>{log.ip || '-'}</TableCell>
                  <TableCell>{log.detalhe || '-'}</TableCell>
                  <TableCell>{log.dados ? JSON.stringify(log.dados) : '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default LogsAdmin;
